import vtooltip from './vtooltip';

export default {
    mixins: [vtooltip],
    // template:
    //   "<div><i v-tooltip.right='name' class='fa fa-x' :class='icon' :style='{ color: iconColor }' @click='click'></i><br></div>",
    data() {
        return {
            color: {
                enabled: 'white',
                active: '#2ecc71',
                disabled: 'gray',
            },
            styles: {},
            iconColor: '',
            delay: 400,
        };
    },
    computed: {
        tooltip() {
            let text = '';
            let zhText = this.toolTipText.zh;
            let enText = this.toolTipText.en;
            if ((zhText !== undefined && zhText !== '') || (enText !== undefined && enText !== '')) {
                text = zhText || enText;
            }
            return text;
        },
        iconSrc() {
            return this.iconImage;
        },
    },
    render(h) {
        const directives = [
            {
                name: 'tooltip',
                value: { content: this.tooltip, placement: 'bottom' },
            },
        ];
        const onEvent = {
            click: this.click,
        };
        let el = null;
        if (this.iconImage) {
            el = h('img', {
                directives,
                on: onEvent,
                attrs: {
                    src: this.iconSrc,
                },
                class: 'toolbar-icon',
            });
        } else {
            el = h('i', {
                // class: ['fa fa-x', this.icon],
                class: [this.icon],
                style: {
                    color: this.iconColor,
                    ...this.styles,
                },
                directives,
                on: onEvent,
            });
        }
        return h(
            'div',
            {
                class: 'annotator-tool-item',
            },
            [el],
        );
    },
    methods: {
        click() {
            if (!this.disabled) {
                this.toggleAnimation();
                this.execute();
            }
        },
        toggleAnimation() {
            this.iconColor = this.color.active;
            setTimeout(() => {
                this.iconColor = this.color.enabled;
            }, this.delay);
        },
    },
    created() {
        this.iconColor = this.color.enabled;
    },
};
